import { RouteType } from "types/RouteType";
// import loadHoistOverviewRoute from "./LoadHoistOverview/loadHoistOverview.Route";
// import loadHoistSummaryRoute from "./LoadHoistSummary/loadHoistSummary.Route";
// import loadHoistTrackerRoute from "./LoadHoistTracker/loadHoistTracker.Route";
// import productionOverviewChartRoute from "./ProductionOverviewChart/productionOverviewChart.Route";
import productionOverviewScheduleRoute from "./ProductionOverviewSchedule/productionOverviewSchedule.Route";
import productionScheduleRoute from "./ProductionSchedule/productionSchedule.Route";
import scheduleGeneratorRoute from "./ScheduleGenerator/ScheduleGenerator.Route";
import departmentProductionScheduleRoute from "./DepartmentProductionSchedule/departmentProductionSchedule.Route";
import structureCastProductionScheduleRoute from "./MillerProductionSchedule/millerProductionSchedule.Route";
import structureCastJobsClientsRoute from "./MillerJobsClients/millerJobsClients.Route";

const schedulingRoutesList: RouteType[] = [
    // loadHoistOverviewRoute,
    // loadHoistSummaryRoute,
    // ...loadHoistTrackerRoute,
    // ...productionOverviewChartRoute,
    // ...productionOverviewScheduleRoute,
    // ...productionScheduleRoute,
    // scheduleGeneratorRoute,
    ...departmentProductionScheduleRoute,
    structureCastProductionScheduleRoute,
    structureCastJobsClientsRoute,
];

export default schedulingRoutesList;
